import { useState, useEffect, useCallback } from 'react';
import { bffQuery } from '@parsina/framework/clinical/src/lib/bffClient';

const LIST_ENCOUNTERS_QUERY = `
  query ListEncounters(
    $status: String, $search: String, $clinicId: ID, $type: String
    $fromTs: Float, $toTs: Float, $limit: Int, $offset: Int
  ) {
    listEncounters(
      status: $status, search: $search, clinicId: $clinicId, type: $type
      fromTs: $fromTs, toTs: $toTs, limit: $limit, offset: $offset
    ) {
      items {
        id
        patientId
        patientName
        clinicId
        type
        status
        scheduledDate
        createdAt
        fileNumber
      }
      total
    }
  }
`;

// سوابق ویزیت is date-scoped and paged. `fromTs`/`toTs` are epoch-ms bounds (the same
// convention as the accounting report); both null ⇒ today in Tehran. `total` is the
// count across the whole range so the caller can drive page controls.
export function useEncounters(
  status = null, search = '', clinicId = null, type = null,
  { fromTs = null, toTs = null, limit = null, offset = 0 } = {},
) {
  const [encounters, setEncounters] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [nonce, setNonce] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    bffQuery(LIST_ENCOUNTERS_QUERY, {
      status:   status   || null,
      search:   search   || null,
      clinicId: clinicId || null,
      type:     type     || null,
      fromTs:   fromTs   ?? null,
      toTs:     toTs     ?? null,
      limit:    limit    || null,
      offset:   offset   || 0,
    })
      .then(data => {
        if (cancelled) return;
        const page = data.listEncounters || { items: [], total: 0 };
        setEncounters(page.items || []);
        setTotal(page.total || 0);
      })
      .catch(err => { if (!cancelled) { setError(err); setEncounters([]); setTotal(0); } })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [status, search, clinicId, type, fromTs, toTs, limit, offset, nonce]);

  const reload = useCallback(() => setNonce(n => n + 1), []);

  return { encounters, total, loading, error, reload };
}
